import { render, staticRenderFns } from "./liveSystemSetting.vue?vue&type=template&id=b8167558&"
import script from "./liveSystemSetting.vue?vue&type=script&lang=js&"
export * from "./liveSystemSetting.vue?vue&type=script&lang=js&"
import style0 from "./liveSystemSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports